/**
 * Google Drive API Configuration
 *
 * To set up:
 * 1. Follow the setup guide in GOOGLE_DRIVE_SETUP.md
 * 2. Replace the placeholder values below with your actual credentials
 */

export const GOOGLE_DRIVE_CONFIG = {
  // Replace with your API Key from Google Cloud Console
  apiKey: 'AIzaSyB1HTcz4RayLIe3mGKGSPK8Qk9Qiz4NYEM',

  // Replace with your OAuth 2.0 Client ID from Google Cloud Console
  clientId: '1086564854147-p72mctflfahtkgvq13v771g9rmcagv8q.apps.googleusercontent.com',

  // Google Drive API discovery document (don't change)
  discoveryDoc: 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',

  // Scopes - using minimal permissions for security (don't change)
  scopes: 'https://www.googleapis.com/auth/drive.file'
};

// Validation helper
export const validateConfig = (): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  if (GOOGLE_DRIVE_CONFIG.apiKey === 'YOUR_API_KEY_HERE') {
    errors.push('API Key not configured - please follow GOOGLE_DRIVE_SETUP.md');
  }

  if (GOOGLE_DRIVE_CONFIG.clientId === 'YOUR_CLIENT_ID_HERE') {
    errors.push('Client ID not configured - please follow GOOGLE_DRIVE_SETUP.md');
  }

  if (
    GOOGLE_DRIVE_CONFIG.apiKey &&
    GOOGLE_DRIVE_CONFIG.apiKey !== 'YOUR_API_KEY_HERE' &&
    !GOOGLE_DRIVE_CONFIG.apiKey.startsWith('AIza')
  ) {
    errors.push('API Key format appears invalid (should start with "AIza")');
  }

  if (
    GOOGLE_DRIVE_CONFIG.clientId &&
    GOOGLE_DRIVE_CONFIG.clientId !== 'YOUR_CLIENT_ID_HERE' &&
    !GOOGLE_DRIVE_CONFIG.clientId.includes('.googleusercontent.com')
  ) {
    errors.push('Client ID format appears invalid (should end with ".googleusercontent.com")');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

// Development helper - shows current config status
export const getConfigStatus = () => {
  const validation = validateConfig();

  return {
    ...validation,
    hasApiKey: GOOGLE_DRIVE_CONFIG.apiKey !== 'YOUR_API_KEY_HERE',
    hasClientId: GOOGLE_DRIVE_CONFIG.clientId !== 'YOUR_CLIENT_ID_HERE',
    config: {
      apiKey: GOOGLE_DRIVE_CONFIG.apiKey.substring(0, 10) + '...',
      clientId: GOOGLE_DRIVE_CONFIG.clientId.substring(0, 20) + '...',
      scopes: GOOGLE_DRIVE_CONFIG.scopes
    }
  };
};
